import { ActionTree } from 'vuex';
import {
  EUpdateDirectoryAction,
  EUpdateDirectoryMutation,
  state as defaultState,
} from './update-directory.constants';
import { IUpdateDirectoryState } from './update-directory.types';
import { IDirectory } from '@/api/directories/types/directory';
import { translate } from '@/helpers/translation.helper';
import { RootState } from '@/store/store';
import { DirectoryService } from '@/api/directories/services/directory.service';
import { alertNamespace, EAlertAction } from '@/alert/store/alert.constants';

export const actions: ActionTree<IUpdateDirectoryState, RootState> = {
  async [EUpdateDirectoryAction.Update](
    { dispatch, commit },
    { id, title }: { id: string; title: string }
  ) {
    commit(EUpdateDirectoryMutation.SetUpdating, true);
    try {
      const directory: IDirectory = await DirectoryService.update({ title, id });
      dispatch(EUpdateDirectoryAction.UpdateSuccess, directory);
    } catch (e) {
      dispatch(EUpdateDirectoryAction.UpdateFailed);
    }
  },
  [EUpdateDirectoryAction.UpdateSuccess]({ commit }, updatedDirectory: IDirectory) {
    commit(EUpdateDirectoryMutation.SetUpdatedDirectory, updatedDirectory);
    commit(EUpdateDirectoryMutation.SetUpdating, false);
  },
  [EUpdateDirectoryAction.UpdateFailed]({ dispatch, commit }) {
    commit(EUpdateDirectoryMutation.SetUpdatedDirectory, { ...defaultState }.updatedDirectory);
    commit(EUpdateDirectoryMutation.SetUpdating, false);
    dispatch(`${alertNamespace}/${EAlertAction.ShowDanger}`, translate('could-not-update-folder'), {
      root: true,
    });
  },
  [EUpdateDirectoryAction.Reset]({ commit }) {
    commit(EUpdateDirectoryMutation.SetState, { ...defaultState });
  },
};
